import map from 'lodash/map.js';

import Model from '@/models/Model.js';

export default class PageGroup extends Model {
    static entity = 'page_group';

    static primaryKey = ['page_id', 'group_id'];

    static fields() {
        return {
            id: this.attr(null),
            page_id: this.attr(null),
            group_id: this.attr(null),

            ...super.fields(),
        };
    }

    static async syncGroups(model) {
        const endpoint = `api/edit-pages/${model.slug}/groups`;

        const currentGroupIds = map(model.groups, 'id');

        await this.store().dispatch('AutoSave/setSaving', 'entities/page_group');

        const response = await this.api().put(
            endpoint,
            {
                groups: currentGroupIds,
            },
            {
                dataTransformer: () => {
                    return currentGroupIds.map(id => ({
                        page_id: model.id,
                        group_id: id,
                    }));
                },
                save: false,
            }
        );

        await PageGroup.deleteAll();

        response.save();

        await this.store().dispatch('AutoSave/setSaved', 'entities/page_group');

        return response.response.data;
    }
}
